import { ButtonList } from '@dixa/lib-shared-habla';
import { FloatingDiv } from 'articleEditor/components/floatingDiv/floatingDiv';
import { Popover } from 'articleEditor/components/popover';
import usePointHover from 'articleEditor/hooks/usePointHover';
import cx from 'classnames';
import { useMyEditorRef } from 'lib-knowledge-document-structure/plateHooks';
import { Point } from 'lib-knowledge-document-structure/slate/package';
import { useEffect, useMemo, useRef } from 'react';
import { useSnapshot } from 'valtio';

import s from './blockShortcutMenu.module.scss';
import { onSelectBlock } from './createShortcutPlugin';
import { actions, shortcutState } from './shortcut.store';

export function BlockShortcutMenu(): JSX.Element {
  const editor = useMyEditorRef();
  const { point, filteredBlocks, selectedBlockIndex, newLine, anchorElement } =
    useSnapshot(shortcutState);

  const floatingPoint = useMemo(() => {
    return newLine && point
      ? { path: [point.path[0]], offset: 0 }
      : (point as Point);
  }, [newLine, point]);

  const floatingProps = usePointHover({
    point: floatingPoint,
    anchorElement: anchorElement as HTMLElement | null,
    floatingDivId: 'blockShortcutMenu',
  });

  const selectedItemRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    selectedItemRef.current?.scrollIntoView({ block: 'nearest' });
  }, [selectedBlockIndex]);

  return (
    <FloatingDiv id="blockShortcutMenu" floatingProps={floatingProps}>
      {floatingProps.isOpen && (
        <Popover className={s['shortcutMenu']}>
          {filteredBlocks.length > 0 ? (
            <ButtonList>
              {filteredBlocks.map((block, index) => (
                <ButtonList.Item
                  className={cx(
                    selectedBlockIndex === index && s['shortcutItemSelected'],
                  )}
                  buttonClassName={s['shortcutItemButton']}
                  icon={block.icon}
                  key={block.type}
                  ref={
                    selectedBlockIndex === index ? selectedItemRef : undefined
                  }
                  onClick={() => onSelectBlock(editor, block)}
                  buttonProps={{
                    onMouseDown(e) {
                      // Make sure the onClick here registers instead of the blur in the editor (which hides the menu)
                      e.preventDefault();
                      e.stopPropagation();
                    },
                    onMouseMove() {
                      if (selectedBlockIndex === index) return;
                      actions.setIndex(index);
                    },
                  }}
                >
                  {block.label}
                </ButtonList.Item>
              ))}
            </ButtonList>
          ) : (
            <div className={s['blockMenuMessage']}>No&nbsp;results</div>
          )}
        </Popover>
      )}
    </FloatingDiv>
  );
}
